import i18n from "i18n";

const Messages = {
  Create: i18n.t('notifications.common.create', { dataType: i18n.t('labels.conversation') }),
  Update: i18n.t('notifications.common.update', { dataType: i18n.t('labels.conversation') }),
  Delete: i18n.t('notifications.common.delete', { dataType: i18n.t('labels.conversation') }),
  Embeddings: i18n.t('notifications.aiChat.embeddings'),
};

export default Messages;

i18n.on('languageChanged', () => {
  Messages.Create = i18n.t('notifications.common.create', { dataType: i18n.t('labels.conversation') });
  Messages.Update = i18n.t('notifications.common.update', { dataType: i18n.t('labels.conversation') });
  Messages.Delete = i18n.t('notifications.common.delete', { dataType: i18n.t('labels.conversation') });
  Messages.Embeddings = i18n.t('notifications.aiChat.embeddings');
});